var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories-item",on:{"click":function($event){return _vm.$emit('edit-categories', _vm.categoriesItem)}}},[_vm._v(" "+_vm._s(_vm.categoriesItem.name)+" ("+_vm._s(_vm.categoriesItem.issues_count)+") "),_c('font-awesome-icon',{attrs:{"icon":_vm.dataIconPencilAlt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }